import css from './../../../assets/images/techIcons/css.svg';
import git from './../../../assets/images/techIcons/git.svg';
import github from './../../../assets/images/techIcons/github.svg';
import html from './../../../assets/images/techIcons/html.svg';
import javascript from './../../../assets/images/techIcons/javascript.svg';
import jquery from './../../../assets/images/techIcons/jquery.svg';
import react from './../../../assets/images/techIcons/react.svg';
import sass from './../../../assets/images/techIcons/sass.svg';
import threejs from './../../../assets/images/techIcons/threejs.svg';
import node from './../../../assets/images/techIcons/node.svg';
import bootstrap from './../../../assets/images/techIcons/bootstrap.svg';


const images = {
    css, git, github, html, javascript, jquery, react, sass, threejs, node, bootstrap
};

export default images;